/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPORGANISATIONCLASSIFICATION = {
    FinancialInstitution: '01',
    NonFinancialInstitution: '02'
} as const;
export type IAPORGANISATIONCLASSIFICATION = typeof IAPORGANISATIONCLASSIFICATION[keyof typeof IAPORGANISATIONCLASSIFICATION];


export function IAPORGANISATIONCLASSIFICATIONFromJSON(json: any): IAPORGANISATIONCLASSIFICATION {
    return IAPORGANISATIONCLASSIFICATIONFromJSONTyped(json, false);
}

export function IAPORGANISATIONCLASSIFICATIONFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPORGANISATIONCLASSIFICATION {
    return json as IAPORGANISATIONCLASSIFICATION;
}

export function IAPORGANISATIONCLASSIFICATIONToJSON(value?: IAPORGANISATIONCLASSIFICATION | null): any {
    return value as any;
}

